import { FourColumns } from './FourColumns';
import { ThreeColumns } from './ThreeColumns';
import { TwoColumns } from './TwoColumns';
import { OneColumn } from './OneColumn';
import { TwoColumnsPrimarySecondary } from './TwoColumnsPrimarySecondary';
export var GridLayout = {
  FourColumns: FourColumns,
  ThreeColumns: ThreeColumns,
  TwoColumns: TwoColumns,
  TwoColumnsPrimarySecondary: TwoColumnsPrimarySecondary,
  OneColumn: OneColumn
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Grid/index.js
// module id = 826
// module chunks = 0